var ClientActions = /** @class */ (function () {
    function ClientActions(trackEndpointUrl, hash) {
        this.trackEndpointUrl = trackEndpointUrl;
        this.hash = hash;
    }
    ClientActions.prototype.track = function (result) {
        window
            .fetch(this.trackEndpointUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                result: result
            })
        })["catch"](console.error);
    };
    ClientActions.prototype.refreshFinnSession = function () {
        fetch("/auth/refresh?hash=".concat(this.hash), {
            credentials: 'include'
        })["catch"](console.error);
    };
    return ClientActions;
}());
export default ClientActions;
